import pino from 'pino';
import { isDevelopment, version } from '../../config/public/environment';
import type { Logger } from './types';

let logger: Logger;

export function sLog() {
  if (!logger) {
    logger = initLogger();
  }
  return logger ?? console;
}

function initLogger() {
  const config = {
    base: null,
    errorKey: 'error',
    formatters: {
      level: (label: string) => {
        return { level: label };
      }
    },
    level: 'info',
    bindings: (bindings: Record<string, unknown>) => {
      return {
        ...bindings,
        node_version: process.version,
        docker_image_tag: version
      };
    },
    ...(isDevelopment
      ? {
          transport: {
            target: 'pino-pretty',
            options: {
              colorize: true,
              singleLine: true
            }
          }
        }
      : {})
  };

  const jsonLogger = pino(config);

  const serverLogger: Logger = {
    debug(msg, obj) {
      jsonLogger.debug(obj, msg);
    },
    info(msg, obj) {
      jsonLogger.info(obj, msg);
    },
    warn(msg, obj) {
      jsonLogger.warn(obj, msg);
    },
    error(msg, obj) {
      jsonLogger.error(obj, msg);
    }
  };
  return serverLogger;
}
